module.exports = __webpack_public_path__ + "img/mobile-13.e8ffcbfe.png";